import { createFeature } from "@ngrx/store";
import { userContactsReducer } from "@State/Reducers/contacts.reducer";

export const selectUserContactsFeature = createFeature({
  name: 'userContacts',
  reducer: userContactsReducer
})
